import axios from "axios";
import {EXPENSE_API_URL, PIPELINE_EXPENSE_API_URL} from "../constants/api_routes";
import {getHeader} from "./user_api";

export const getExpenses = async (startDate,endDate) => {
    try {
        if(startDate && endDate){
            return await axios.get(`${EXPENSE_API_URL}/list?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        }
        else {
            return await axios.get(`${EXPENSE_API_URL}/list`, {headers: getHeader()});
        }

    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getExpenseEstimateList = async () => {
    try {
        return await axios.get(`${PIPELINE_EXPENSE_API_URL}/list`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getExpenseDetail = async (id) => {
    try {
        return await axios.get(`${EXPENSE_API_URL}/detail?expense_id=${id}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getEstimateDetails = async (id) => {
    try {
        return await axios.get(`${PIPELINE_EXPENSE_API_URL}/detail?pipeline_expense_id=${id}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


export const changeExpenseStatus = async (formData) => {
    try {
        return await axios.post(`${EXPENSE_API_URL}/update_status`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const changeExpenseEstimateStatus = async (formData) => {
    try {
        return await axios.post(`${PIPELINE_EXPENSE_API_URL}/update_status`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


export const updateExpenseEstimate = async (formData) => {
    try {
        return await axios.post(`${PIPELINE_EXPENSE_API_URL}/update`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const deleteExpense = async (expenseId) => {
    try {
        return await axios.delete(`${PIPELINE_EXPENSE_API_URL}/delete?pipeline_expense_id=${expenseId}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const createExpense = async (formData) => {
    try {
        return await axios.post(`${PIPELINE_EXPENSE_API_URL}/create`,formData,{headers:getHeader()});
    } catch (e){
        return {
            success: true,
            message:e.response.error,
            status:e.response.status
        }
    }
};

export const approveSelectedExpenses =  async (formData) => {
    try {
        return await axios.post(`${PIPELINE_EXPENSE_API_URL}/update_all_status`,formData,{headers:getHeader()});
    } catch (e) {
        return {
            success:false,
            status:e.response.status
        }
    }
};


// WEBPACK FOOTER //
// ./src/data/account_expense_api.js